(function () {
    'use strict';

    (function ($) {
        // Initialize news slider
        function initializeNewsSlider() {
            const $newsSlider = $('.news-slider-slick');
            const hasLiveMatch = $('.live-match-widgetx.loaded').length > 0; // Ensure `loaded` class is present

            // Reinitialize slider if already initialized
            if ($newsSlider.hasClass('slick-initialized')) {
                $newsSlider.slick('unslick');
            }

            $newsSlider.slick({
                dots: false,
                infinite: true,
                speed: 600,
                slidesToShow: hasLiveMatch ? 2 : 3,
                slidesToScroll: 1,
                autoplay: false,
                autoplaySpeed: 2000,
                arrows: true,
                responsive: [
                    {
                        breakpoint: 1260,
                        settings: {
                            slidesToShow: hasLiveMatch ? 2 : 3,
                        }
                    },
                    {
                        breakpoint: 1023,
                        settings: {
                            slidesToShow: hasLiveMatch ? 2 : 3,
                        }
                    },
                    {
                        breakpoint: 980,
                        settings: {
                            slidesToShow: hasLiveMatch ? 1 : 3,
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                        }
                    }
                ]
            });

            const $newsSliderContainer = $('.news-slider-live-score');
            if (hasLiveMatch) {
                $newsSliderContainer.addClass('with-live-match');
                $('.live-match-detail').addClass('has-live-match');
            } else {
                $newsSliderContainer.removeClass('with-live-match');
                $('.live-match-detail').removeClass('has-live-match');
            }
        }
        // old
        // Handle live match updates
        // function handleLiveMatchUpdates() {
        //     const $liveMatchWidgets = $('.live-match-widget');

        //     $liveMatchWidgets.each(function () {
        //         const $widget = $(this);
        //         const matchId = $widget.data('matchid');

        //         // Show loader
        //         $widget.find('.loaderlive').show();

        //         // AJAX request to get live match widget content
        //         $.ajax({
        //             type: "GET",
        //             cache: false,
        //             url: ssAjax.ajaxurl,
        //             data: { nonce: ssAjax.nonce, matchid: matchId, action: 'getlivewidget' },
        //             success: function (response) {
        //                 $widget.find('.loaderlive').hide();
        //                 $widget.html(response);
        //                 $widget.addClass('loaded'); // Mark as loaded

        //                 // Reinitialize news slider with the updated state
        //                 initializeNewsSlider();

        //                 // Start periodic updates for live matches
        //                 if ($('.mstus').val() === 'live') {
        //                     setInterval(() => {
        //                         updateLiveMatch($widget);
        //                     }, 60000);
        //                 }
        //             }
        //         });
        //     });
        // }

        // Update live match content
        // function updateLiveMatch($widget) {
        //     const matchId = $widget.data('matchid');

        //     $widget.find('.loaderlive').show();
        //     $.ajax({
        //         type: "GET",
        //         cache: false,
        //         url: ssAjax.ajaxurl,
        //         data: { nonce: ssAjax.nonce, matchid: matchId, action: 'getlivewidget' },
        //         success: function (response) {
        //             $widget.find('.loaderlive').hide();
        //             $widget.html(response);

        //             // Reinitialize news slider with updated state
        //             initializeNewsSlider();
        //         }
        //     });
        // }
        // old end

        function handleLiveMatchUpdates() {
            const $liveMatchWidgetsMen = $('.live-match-widgetx.men');
            const $liveMatchWidgetsWomen = $('.live-match-widgetx.women');

            //live match
           
            handleLiveMatchwidget($liveMatchWidgetsMen);
            handleLiveMatchwidget($liveMatchWidgetsWomen);

            
            
        }
        function handleLiveMatchwidget($widget) {

            const matchId = $widget.data('matchid');

            // Show loader
            $widget.find('.loaderlive').show();

            // AJAX request to get live match widget content
            $.ajax({
                type: "GET",
                cache: false,
                url: ssAjax.ajaxurl,
                data: { nonce: ssAjax.nonce, matchid: matchId, action: 'getlivewidget2' },
                success: function (response) {
                    $widget.find('.loaderlive').hide();
                    $widget.html(response);
                    $widget.addClass('loaded'); // Mark as loaded

                    // Reinitialize news slider with the updated state
                    initializeNewsSlider();

                    // Start periodic updates for live matches
                    if ($('.mstus').val() === 'live') {
                        setInterval(() => {
                            updateLiveMatch($widget);
                        }, 60000);
                    }
                }
            });
        }
        // Update live match content
        function updateLiveMatch($widget) {
            const matchId = $widget.data('matchid');

            $widget.find('.loaderlive').show();
            $.ajax({
                type: "GET",
                cache: false,
                url: ssAjax.ajaxurl,
                data: { nonce: ssAjax.nonce, matchid: matchId, action: 'getlivewidget2' },
                success: function (response) {
                    $widget.find('.loaderlive').hide();
                    $widget.html(response);

                    // Reinitialize news slider with updated state
                    initializeNewsSlider();
                }
            });
        }
        // Initialize sliders and live matches
        $(document).ready(function () {
            // Handle live match updates
            if ($('.live-match-widgetx').length > 0) {
                handleLiveMatchUpdates();
            } else {
                // Initialize news slider directly if no live match
                initializeNewsSlider();
            }
        });
    })(jQuery);
})();
